<template>
	<div id="hres80x-history-heal-family" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#historyHealFamily">
      <h3 class="box-title color-skin">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> {{labels['HRES80XP3']['10']}}
      </h3>
    </div>
    <div id="historyHealFamily" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
        	<!-- header -->
          <div class="hisheal-header">{{labels['HRES80XP3']['20']}} {{labels['HRES80XP3']['25']}}</div>
          <!-- header column -->
          <div class="table-overflow">
            <table class="table-1">
              <tr>
                <td class="bg-color-skin text-center" style="width: 10%;">{{labels['HRES80XP3']['30']}}</td>
                <td class="bg-color-skin text-center" style="width: 20%;">{{labels['HRES80XP3']['40']}}</td>
                <td class="bg-color-skin" style="width: 70%;">{{labels['HRES80XP3']['50']}}</td>
              </tr>
              <tr v-for="(dataRow,index) in dataHisHealFamily" :key="index">
                <td class="text-center">{{dataRow.numseq}}</td>
                <td>{{dataRow.desrelat}}</td>
                <td>{{dataRow.dessick}}</td>
              </tr>
            </table>
          </div>
          <div v-if="dataHisHealFamily.length === 0" class="text-center hisheal-nodata">
            No data found.
          </div>
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres80x-history-heal-family',
  props: [
    'labels',
    'dataHisHealFamily'
  ]
}
</script>



// WEBPACK FOOTER //
// historyHealFamily.vue?6e45bfb7